import { createAsyncThunk } from "@reduxjs/toolkit";
import { retrieveAirlineLinks, retrieveCustomerData } from "../../api";

export interface FetchConfigProps {
  configPath: string;
}

export const fetchConfig = createAsyncThunk(
  "config/fetchConfig",
  async ({ configPath }: FetchConfigProps, thunkAPI) => {
    return retrieveCustomerData(configPath);
  }
);

export const fetchAirlineLinks = createAsyncThunk(
  "config/fetchAirlineLinks",
  async (props, thunkAPI) => {
    return retrieveAirlineLinks();
  }
);
